<template>
    <div ref="parent" class="mtg-agents-detail-block__body">
        <div class="mtg-agents-detail-block__head g-text__p _gray g_semibold">Документы</div>
        <div class="mtg-agents-detail-block__docs">
            <a
                v-for="doc in docsList"
                :key="`doc-${doc.id}`"
                :href="doc.props && doc.props.file ? doc.props.file.src : '#!'"
                class="mtg-agents-detail-block__doc u-link__download"
                target="_blank"
            >
                <span v-html="doc.name" class="u-link__download-text g_medium" />
            </a>
        </div>
        <page-nav
            :total-pages="data.nav.NavPageCount"
            parent-class="mtg-agents-detail__nav"
            @changePage="getData"
        ></page-nav>
    </div>
</template>

<script>
import pageNav from '../../PageNav';
import axios from 'axios';
import scrollIt from '../../../modules/scroll-it';

export default {
    name: 'MortAgentsDocsWithPageNav',
    components: {
        pageNav
    },
    props: {
        data: {
            type: Object,
            default () {
                return [];
            }
        },
        category: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: ''
        },
    },
    data () {
        return {
            docsList: []
        };
    },
    created() {
        this.docsList = this.data.data;
        this.allPages = this.data.nav.NavPageCount;
    },
    methods: {
        getData(pageNum) {
            const apiUrl = `/api/v2/content/ia/${this.category}/${this.type}/`;

            axios.get(
                apiUrl,
                {
                    params: {
                        page: pageNum,
                        'page-size': 10
                    }
                },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            ).then(({ data }) => {
                this.docsList = data.data;
                scrollIt(this.$refs.parent, 300);
            }).catch((error) => {
                console.error(error);
            });
        }
    }
};
</script>
